export default __webpack_public_path__ + "static/media/13_galeria.96b9430d.webp";